module.exports = __webpack_public_path__ + "static/media/START.6f33bba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/START.png
// module id = 101
// module chunks = 0